import type { TableViewType } from '../../types';
import { cardsViewSpec } from './cards';
import { gridViewSpec } from './grid';
import type { ViewValidationSpec } from './types';

/**
 * Mapping of view types to view validation.
 */
export const viewSpecs: { [type in TableViewType]: ViewValidationSpec } = {
    grid: gridViewSpec,
    cards: cardsViewSpec,
};
